export default "__VITE_ASSET__C6I3Ss$L__"